var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var _a;
import { Chart, registerables } from 'chart.js';
import { extractData } from "../utils";
Chart.register.apply(Chart, __spreadArray([], __read(registerables), false));
var chartDataElement = document.getElementById('chart_data');
var chartData = (_a = extractData(chartDataElement)) !== null && _a !== void 0 ? _a : [];
var BRAND_COLOR = '#f5809d';
var SECONDARY_COLOR = '#24252e';
var PLACEHOLDER_COLOR = '#9DABB5';
var valueLabelsPlugin = {
    id: 'valueLabels',
    afterDatasetsDraw: function (chart) {
        var ctx = chart.ctx, data = chart.data, chartArea = chart.chartArea;
        ctx.save();
        ctx.font = '12px sans-serif';
        ctx.textAlign = 'center';
        chart.getDatasetMeta(0).data.forEach(function (point, index) {
            var _a, _b;
            var value = (_a = data.datasets[0]) === null || _a === void 0 ? void 0 : _a.data[index];
            var label = (_b = data.labels) === null || _b === void 0 ? void 0 : _b[index];
            if (typeof value !== 'number' || typeof label !== 'string')
                return;
            var _c = point.tooltipPosition(), x = _c.x, y = _c.y;
            ctx.fillStyle = PLACEHOLDER_COLOR;
            ctx.textBaseline = 'bottom';
            ctx.fillText(String(value), x, y - 4);
            ctx.fillStyle = SECONDARY_COLOR;
            ctx.textBaseline = 'bottom';
            ctx.fillText(label, x, chartArea.bottom + 20);
        });
        ctx.restore();
    },
};
Chart.register(valueLabelsPlugin);
var baseOptions = {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
        padding: { top: 20, left: 20, right: 20, bottom: 20 },
    },
    plugins: {
        legend: { display: false },
        tooltip: { enabled: false },
    },
    scales: {
        x: {
            display: false,
            grid: { display: false },
        },
        y: {
            display: false,
            beginAtZero: true,
        },
    },
    elements: {
        point: { radius: 2 },
    },
};
function createDataset(ctx, values) {
    var gradient = ctx.createLinearGradient(0, 0, 0, ctx.canvas.height);
    gradient.addColorStop(0, 'rgba(255, 221, 229, 1)');
    gradient.addColorStop(1, 'rgba(255, 255, 255, 0)');
    return {
        data: values,
        borderColor: BRAND_COLOR,
        borderWidth: 2,
        backgroundColor: gradient,
        pointBorderColor: SECONDARY_COLOR,
        pointBackgroundColor: BRAND_COLOR,
        pointBorderWidth: 1,
        tension: 0.32,
        fill: 'start',
    };
}
export default function initPerfumeCharts() {
    var e_1, _a;
    var charts = [];
    try {
        for (var chartData_1 = __values(chartData), chartData_1_1 = chartData_1.next(); !chartData_1_1.done; chartData_1_1 = chartData_1.next()) {
            var _b = chartData_1_1.value, canvasId = _b.canvasId, labels = _b.labels, values = _b.values;
            var canvas = document.getElementById(canvasId);
            var ctx = canvas === null || canvas === void 0 ? void 0 : canvas.getContext('2d');
            if (!ctx)
                continue;
            charts.push(new Chart(ctx, {
                type: 'line',
                data: { labels: labels, datasets: [createDataset(ctx, values)] },
                options: baseOptions,
            }));
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (chartData_1_1 && !chartData_1_1.done && (_a = chartData_1.return)) _a.call(chartData_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return charts;
}
